import type { RouteObject as AdminRouteObject } from "react-router-dom";
import type { AdminDashboardDependencies } from "../composition/create-admin-dashboard-dependencies";
import { OperationContextScreen } from "../../features/operation-context/operation-context-screen";

export function createOperationContextRoute(dependencies: AdminDashboardDependencies): AdminRouteObject {
  return {
    path: "operation-context",
    element: <OperationContextScreen dependencies={dependencies} />,
  };
}
